import React, { useEffect, useRef } from 'react'
import Image from 'next/image'

export function Brand() {
  const trackRef = useRef<HTMLDivElement | null>(null)
  const firstSetRef = useRef<HTMLDivElement | null>(null)
  const brands = [
    { src: '/static/customers/bytedance.svg', alt: 'Bytedance' },
    { src: '/static/customers/airbnb.svg', alt: 'Airbnb' },
    { src: '/static/customers/nyu.svg', alt: 'New York University' },
    { src: '/static/customers/realadvisor.svg', alt: 'RealAdvisor' },
    { src: '/static/customers/umich.svg', alt: 'University of Michigan' },
    { src: '/static/customers/hope.svg', alt: 'Hope College' },
    { src: '/static/customers/gameskraft.webp', alt: 'Gameskraft' },
    { src: '/static/customers/esimple.png', alt: 'Esimple' },
    { src: '/static/customers/wizishop.png', alt: 'Wizishop' },
    { src: '/static/customers/aria.webp', alt: 'Aria' }
  ]

  useEffect(() => {
    const track = trackRef.current
    const firstSet = firstSetRef.current

    if (!track || !firstSet) {
      return
    }

    let offset = 0
    let frameId = 0
    const speed = 0.6

    const tick = () => {
      const loopWidth = firstSet.offsetWidth

      if (!loopWidth) {
        frameId = requestAnimationFrame(tick)
        return
      }

      offset += speed

      if (offset >= loopWidth) {
        offset -= loopWidth
      }

      track.style.transform = `translate3d(-${offset}px, 0, 0)`
      frameId = requestAnimationFrame(tick)
    }

    frameId = requestAnimationFrame(tick)

    return () => {
      cancelAnimationFrame(frameId)
    }
  }, [])

  return (
    <div className="brandWrap py-12">
      <div className="px-4 sm:px-6">
        <div className="overflow-hidden whitespace-nowrap">
          <div ref={trackRef} className="flex w-max will-change-transform">
            {[0, 1].map(copyIndex => (
              <div
                key={copyIndex}
                ref={copyIndex === 0 ? firstSetRef : undefined}
                className="flex shrink-0 items-center gap-16 pr-16"
                aria-hidden={copyIndex === 1}
              >
                {brands.map((brand, index) => (
                  <Image
                    key={`${copyIndex}-${index}`}
                    src={brand.src}
                    alt={brand.alt}
                    width={160}
                    height={96}
                    className="h-24 w-40 object-contain grayscale transition duration-300 hover:grayscale-0"
                  />
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}
